import { cn } from '@/lib/utils'
import { play } from '@/services/media-manager.service'
import { useRef, useState } from 'react'
import ExternalLink from './ExternalLink'

export default function VideoPlayer({ src, className }: { src: string; className?: string }) {
  const [error, setError] = useState(false)
  const videoRef = useRef<HTMLVideoElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)

  if (error) {
    return <ExternalLink url={src} />
  }

  return (
    <div ref={containerRef}>
      <video
        ref={videoRef}
        controls
        playsInline
        className={cn('rounded-lg max-h-[80vh] sm:max-h-[60vh] border', className)}
        src={src}
        onClick={(e) => e.stopPropagation()}
        onPlay={(event) => {
          play(event.currentTarget)
        }}
        onError={() => setError(true)}
      />
    </div>
  )
}
